module.exports = __webpack_public_path__ + "assets/rocket-new.5271d333.svg";